<template lang="pug">
.flex-col.gap-2
  h3.subtitle Información del Abono
  .flex-col.gap-1.mb-3
    b-row(no-gutters)
      b-col(cols="5" md="3")
        .label.label-text Sub-Total
      b-col(cols="7" md="9")
        span {{ ovData.subtotal }}
    b-row(no-gutters)
      b-col(cols="5" md="3")
        .label.label-text Costo Envío
      b-col(cols="7" md="9")
        span {{ ovData.costo_envio }}
    b-row(no-gutters)
      b-col(cols="5" md="3")
        .label.label-text IVA
      b-col(cols="7" md="9")
        span {{ ovData.iva }}
    b-row(no-gutters)
      b-col(cols="5" md="3")
        .label.label-text Descuento
      b-col(cols="7" md="9")
        span {{ ovData.descuento || '-' }}
    b-row(no-gutters)
      b-col(cols="5" md="3")
        .label.label-text Abono requerido
      b-col(cols="7" md="9")
        span {{ ovData.abono_requerido | formatCurrency }}
    b-row(no-gutters)
      b-col(cols="5" md="3")
        .label.label-text Monto Abonado
      b-col(cols="7" md="9")
        span {{ ovData.monto_abonado | formatCurrency }}
    b-row(no-gutters)
      b-col(cols="5" md="3")
        .label.label-text Total
      b-col(cols="7" md="9")
        span {{ ovData.total }}

  
</template>

<script>
import { LABEL_TIPO_DESPACHO } from '@/utils/labels'
import ChangeDeliveryButton from '@/components/OT/ClientOT/ChangeDeliveryButton.vue'

export default {
  props: {
    ovData: {
      type: Object,
      required: true,
    },
  },

  components: { ChangeDeliveryButton },

  computed: {
    tipoDespacho() {
      if (!this.ovData.despacho) return '---'
      return LABEL_TIPO_DESPACHO[this.ovData.despacho]
    },
  },
}
</script>

<style lang="scss" scoped>
@import '../../../../style/colors.scss';

.label-text {
  color: $samtek-black !important;
}
</style>
